import React, { Suspense, lazy } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { AppLoader } from '../components/AppLoader';
import DocumentationLayout from '../components/DocumentationLayout';
const App = lazy(() => import('../containers/App'));

const Documents = lazy(() => import(/* webpackChunkName: "Documents" */ '../containers/Documents'));

const router = () => {
    return (
        <Suspense fallback={<AppLoader />}>
            <Routes>
                <Route exact path="/signup" element={<App />} />
                <Route path="*" element={<Navigate to="/signup" replace />} />
                <Route
                    exact
                    path="/privacy-policy"
                    element={
                        <DocumentationLayout>
                            <Documents />
                        </DocumentationLayout>
                    }
                />
                <Route
                    exact
                    path="/terms-of-service"
                    element={
                        <DocumentationLayout>
                            <Documents pageName={'terms-of-service'} />
                        </DocumentationLayout>
                    }
                />
                <Route
                    exact
                    path="/cookie-policy"
                    element={
                        <DocumentationLayout>
                            <Documents pageName={'cookie-policy'} />
                        </DocumentationLayout>
                    }
                />
            </Routes>
        </Suspense>
    );
};

export default router;
